import { types } from 'mobx-state-tree';
import Company from '../Company';
const dataPointModel = {
    value: types.string,
    type: types.string,
};
const Details = {
    type: types.string,
    value: types.string,
};
const DataPointModel = types.model(dataPointModel);
const DetailsModel = types.model(Details);
const IntegrationsModel = types.model({
    link: types.maybeNull(types.string),
    name: types.maybeNull(types.string),
    type: types.maybeNull(types.string),
});
const model = {
    id: types.string,
    firstName: types.string,
    lastName: types.string,
    jobTitle: types.string,
    emails: types.array(DataPointModel),
    phones: types.array(DataPointModel),
    company: types.maybe(Company),
    email1: types.optional(types.maybeNull(DetailsModel), null),
    email2: types.optional(types.maybeNull(DetailsModel), null),
    phone1: types.optional(types.maybeNull(DetailsModel), null),
    phone2: types.optional(types.maybeNull(DetailsModel), null),
    integrations: types.map(IntegrationsModel),
    lists: types.optional(types.array(types.string), []),
};
const WishlistModel = types.model(model);
export default WishlistModel;
